import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { Colors } from '@/plugins/colors'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: {
    themes: {
      light: {
        primary: '#222222',
        secondary: '#7f7f7f',
        accent: '#70ad47',
        info: '#2196F3',
        success: Colors.SUCCESS,
        unknown: Colors.UNKNOWN,
        warning: Colors.MINOR,
        major: Colors.MAJOR,
        error: Colors.CRITICAL
      }
    },
    options: {
      customProperties: true
    }
  }
})
